<template>
    <div class="container">
        <!-- <img class="top_icon" :src="mbActiveOutput.actImgPath"/> -->
        <!-- <div class="top_icon" v-if="imgs.length>0">   @click="itemClick(item)" 支付券-->
        <!-- <img class="gallary-img" v-if="mbActiveOutput.templateType=='1'" src='../../assets/images/img_mall_zfq.png' /> -->
        <section class="top_swiper_box" v-if="imgs.length>0">
            <swiper >
                <swiper-slide v-for="(item,index) in imgs" :key="index">
                    <img
                    class="gallary-img"
                    :src="item"
                    />
                </swiper-slide>
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
             </swiper>
                 <!-- <swiper-component :imgs="imgs" cclass="swiper_h"></swiper-component> -->
        </section>
        <!-- </div> -->
        <div class="top_info">
            <span class="top_info_span1">{{mbActiveOutput.actName}}</span>
            <span class="top_info_span2">{{changeintegration}} 积分</span>
            <span class="top_info_span3">剩余:{{overTime}}</span>
        </div>
        <div class="bodyTopLine"></div>
        <div class="body">
            <span class="body_span1">兑换规则</span>
            <span class="body_span2">{{mbActiveOutput.actSubtitle}}</span>
            <span  class="body_span1">兑换详情</span>
            <div v-if="mbActiveOutput.actDetail" class="body_html" v-html="mbActiveOutput.actDetail"></div>
        </div>

        <div class="ExchangefootBg">
            <span  v-if=" mbActiveOutput.exchangeFlag==false &&exchangeData && exchangeData.exchangeNum>0" class="Exchangefoot_span1">兑换时间{{exchangeData.beginTime}}-{{exchangeData.endTime}}</span>
            <span  v-else-if="mbActiveOutput.exchangeFlag==false && exchangeData && exchangeData.exchangeNum==0"  class="Exchangefoot_span1">已抢光</span>
            <span  v-else-if="mbActiveOutput.exchangeNum==0"  class="Exchangefoot_span1">已抢光</span>

            <span  v-else-if="integrationSum<changeintegration" class="Exchangefoot_span1">您的积分不足</span>
            <span @click="showPopupAction()" v-else  class="Exchangefoot_span">立即兑换</span>
        </div>

         <mt-popup v-model="showPopup" position="bottom" class="mint-popup">

            <div class="popup">
                <div class="popupTop">
                    <span class="popupTop_span1" @click="closePopupAction()">取消</span>
                    <span class="popupTop_span2">确认订单</span>
                </div>
                <div class="addressView" v-if="mbActiveOutput.templateType!='1'  && mbActiveOutput.courierType=='1'" >
                    <div class="addressViewBG">
                        <div class="addressView_left">
                            <div class="addressView_left_div">
                                <img class="addressView_left_icon" src="../../assets/images/icon_ziti_address_icon.png"/>
                                <span class="addressView_left_span1">自提地址</span>
                            </div>
                            <span class="addressView_left_span2" >{{mbActiveOutput.selfLiftingAddress}}</span>
                        </div>
                        <div class="addressView_line"></div>
                        <div class="addressView_right" @click="copyTradeCode()" :data-clipboard-text="mbActiveOutput.selfLiftingAddress">
                            <img class="addressView_right_icon" src="../../assets/images/icon_btn_duplicate_icon.png"/>
                            <span class="addressView_right_span" >复制</span>
                        </div>
                    </div>
                </div>

                <div class="popupJifen">
                    <span class="popupJifen_span1">本次兑换消耗积分:</span>
                    <span class="popupJifen_span2">{{mbActiveOutput.exchangeValue}}</span>
                </div>

                <div class="popupfoot">
                    <span  class="popupfoot_span" @click="addMbActiveTrade()">确认兑换</span>
                </div>

            </div>
         </mt-popup>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import {ysygetMbActiveById,addMbActiveTrade  } from "../../utils/api";
import util from '../../utils/util';
import Clipboard from 'clipboard';

export default {
  name: "ExchangeItemDetails",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
      imageList:[],
      imgs:[],
      id:'',
      integrationSum:0,
      changeintegration:0,
      mbAddress:'',
      exchangeData:'',
      mbActiveOutput:'',
      pickUpActive :'',
      showPopup:false,
      overTime:'',
    }
  },
  created () {
       let query = this.$route.query;
      this.mbActiveId=query.id;
      this.getMbActiveById();

  },
  methods: {
      copyTradeCode () {
        var clipboard = new Clipboard('.addressView_right')
        clipboard.on('success', () => {
            util.showToast('复制成功')
            // 释放内存
            clipboard.destroy()
        })
    },
     getMbActiveById(){
            var param = {
               // "memberCode": "1",
                "mbActiveId": this.mbActiveId,// "6691535467797553251", //"6612566953552773219",
               // "marketId":"25",
                "memberCode": this.common.userInfo.memberCode,
                 "marketId":this.common.marketInfo.id,

            }
            ysygetMbActiveById( param).then(res => {
                if (res.res.code === 10000) {
                        this.integrationSum =res.body.integrationSum ;
                        this.mbAddress =res.body.mbAddress ;
                        this.mbActiveOutput =res.body.mbActiveOutput ;
                        console.log(res.body.mbActiveOutput.exchangeData)
                        if(res.body.mbActiveOutput.exchangeData){
                            var arr = JSON.parse(res.body.mbActiveOutput.exchangeData)
                            this.exchangeData = arr[0];
                        }
                        console.log(this.exchangeData);
                        this.timeFn(parseInt(this.mbActiveOutput.actEndTime) );
                        this.imageList =res.body.imageList;
                        this.imgs =[];
                        if( this.imageList ){
                            for(var i=0;i<this.imageList.length;i++){
                                this.imgs.push(this.imageList[i].imgPath)
                            }
                        }
                        // console.log("this.imgs")
                        // console.log(this.imgs)
                        this.changeintegration = this.mbActiveOutput.exchangeValue;
                        if (this.mbActiveOutput.courierType) {
                            if (this.mbActiveOutput.courierType == 1 || this.mbActiveOutput.courierType.split(',')[0] == 1) {
                                this.pickUpActive = 1
                            } else if (this.mbActiveOutput.courierType == 2 || this.mbActiveOutput.courierType.split(',')[1] == 2) {
                                this.pickUpActive = 0
                            }
                        }
                }
            });
      },
      addMbActiveTrade (){
            let courierType;
            if (this.pickUpActive) {
                courierType = "1"
            } else {
                courierType = "2"
            }
            var param = {
               // "memberCode": "1",
                "mbActiveId": this.mbActiveId,
                //"6691535467797553251", //"6612566953552773219",
               // "marketId":"25",
               "memberCode": this.common.userInfo.memberCode,
                 "marketId":this.common.marketInfo.id,
                "activeId": this.mbActiveOutput.id,
                "changeVal":   this.mbActiveOutput.exchangeValue* -1,
                "exchangeNum": 1,
                "actType": this.mbActiveOutput.actType,
                "courierType": courierType
            }
            addMbActiveTrade( param).then(res => {
                if (res.res.code === 10000) {
                    this.showPopup =false;
                     util.showToast(res.res.msg)
                     this.getMbActiveById();

                }else{
                     util.showToast(res.res.msg)
                    console.log(res.res.msg)
                }
            });

        },
        showPopupAction(){
            this.showPopup =true;
        },
         closePopupAction(){
            this.showPopup =false;
        },

        timeFn(d1) {//di作为一个变量传进来
            //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
            var  dateEnd= new Date(d1);//将-转化为/，使用new Date
            var dateBegin = new Date();//获取当前时间
            var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
            var leave1=dateDiff%(24*3600*1000) //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))//计算出小时数
            //计算相差分钟数
            var leave2=leave1%(3600*1000) //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))//计算相差分钟数
            //计算相差秒数
            var leave3=leave2%(60*1000) //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
            this.overTime = dayDiff+"天 "+hours+"小时 ";
        }


     } ,

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    position: relative;
    background:#ffffff;
    .flex(column);
}

.top_icon{
    width:100%;
    height:562px;
}
 .top_swiper_box{
        height:562px;
        width:100%;
        // background-color: blue;
        // box-sizing:border-box;
        .gallary-img{
            height:562px;
            width:100%;
        }
}

.top_info{
    width:100%;
    height:174px;
    background:rgba(255,255,255,1);
    flex-direction: column;
    display: flex;
    position: relative;
    .top_info_span1{
        margin-top: 28px;
        margin-left: 28px;
        height:50px;
        font-size:36px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:50px;
        .textOver(500px);

    }
    .top_info_span2{
         margin-top: 20px;
         margin-left: 28px;
         height:48px;
         font-size:40px;
         font-weight:500;
         color:rgba(255,126,30,1);
         line-height:48px;
    }
    .top_info_span3{
        position: absolute;
        top: 28px;
        right: 28px;
        padding-left: 14px;
        padding-right: 14px;
        height:44px;
        background:rgba(252,63,86,0.1);
        border-radius:22px;
        font-size:26px;
        font-weight:400;
        color:rgba(252,63,86,1);
        line-height:44px;

    }

}
.bodyTopLine{
    width: 100%;
    height: 20px;
    background-color: #eeeeee
}
.body{
    // margin-top: 20px;
    padding-bottom: 20px;
    min-height: 456px;
    margin-bottom: 120px;
    width: 100%;
     background-color: #ffffff;
    flex-direction: column;
    display: flex;
    .body_span1{
        margin-top: 40px;
        margin-left: 28px;
        height:44px;
        font-size:32px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;

    }
    .body_span2{
        margin-top: 20px;
        margin-left: 28px;
        width:692px;
        font-size:28px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:40px;

    }
    .body_html{
         margin-top: 20px;
         margin-left: 28px;
         width:692px;
         margin-bottom: 20px;
         /deep/ strong {
            font-weight: bold;
            .fontSize(15px);
            line-height: 50px;
        }
        /deep/ p {
            .fontSize(14px);
            color: rgba(0, 0, 0, 0.9);
            line-height: 40px;
        }
        /deep/ span {
            .fontSize(14px);
            color: rgba(0, 0, 0, 0.9);
            line-height: 40px;
        }
        /deep/ img {
            max-width: 100%;
            min-width: 40%;
            margin: 10px auto;
            height: auto;
            display: block;
        }
        /deep/ figcaption {
            text-align: center;
            .fontSize(14px);
            line-height: 50px;
        }
        /deep/ tr,
        td,
        th {
            .fontSize(14px);
        }
    }


}

 .ExchangefootBg{
        position: fixed;
        left: 0;
        bottom: 0;
        display: flex;
        width: 750px;
        height: 120px;
        background-color: #ffffff;
        .Exchangefoot_span{
            // display: flex;
            margin-top:16px;
            margin-left: 28px;
            width:694px;
            height:88px;
            background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
            border-radius:8px;
            text-align: center;
            font-size:34px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:88px;
        }
        .Exchangefoot_span1{
             margin-top:16px;
            margin-left: 28px;
            width:694px;
            height:88px;
            background:#BBBBBB;
            border-radius:8px;
            text-align: center;
            font-size:34px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:88px;

        }
    }

    .popup{
        width:750px;
        height:560px;
        // background:rgba(255,255,255,1);
       border-radius:16px 16px 0px 0px;
       .popupJifen{
            margin-top: 32px;
            width: 100%;
            justify-content: center;
            flex-direction: row;
             display: flex;
            .popupJifen_span1{
                height:44px;
                font-size:28px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:40px;

            }
            .popupJifen_span2{
                height:44px;
                font-size:28px;
                font-weight:400;
                color:#FF7E1E;
                line-height:40px;

            }
        }
       .popupTop{
           flex-direction: row;
           display: flex;
           width:100%;
           height:100px;
           background:rgba(255,255,255,1);
           border-radius:16px 16px 0px 0px;
           .popupTop_span1{
               margin-left: 28px;
               margin-top: 30px;
               height:42px;
               font-size:30px;
               font-weight:400;
               color:rgba(51,51,51,1);
               line-height:42px;

           }
           .popupTop_span2{
               margin-left: 216px;
               margin-top: 26px;
               height:50px;
               font-size:36px;
               font-weight:500;
               color:rgba(51,51,51,1);
               line-height:50px;
           }
       }
         .popupfoot{
                margin-top: 28px;
                width: 100%;
                height:120px;
                // background:red;
                display: flex;
                 .popupfoot_span{
                    // display: flex;
                    flex-direction: row;
                    margin-top:16px;
                    margin-left: 28px;
                    width:694px;
                    height:88px;
                    background:linear-gradient(90deg,rgba(255,181,64,1) 0%,rgba(255,126,30,1) 100%);
                    border-radius:8px;
                    text-align: center;
                    font-size:34px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:88px;
                }
            }
       .addressView{
        width: 100%;
        height:212px;
        background:rgba(255,255,255,1);
        .addressViewBG{
            margin-top: 20px;
            width: 92.54%;
            margin-left: 28px;
            height:196px;
            background:rgba(248,248,248,1);
            border-radius:8px;
            display: flex;
            flex-direction: row;
            .addressView_left{
                margin-left: 20px;
                margin-top: 30px;
                width: 516px;
                // background-color: blue;
                display: flex;
                flex-direction: column;
                .addressView_left_div{
                    display: flex;
                    flex-direction: row;
                    .addressView_left_icon{
                        // background-color: blue;
                        margin-top: 5px;
                        width: 24px;
                        height: 30px;
                    }
                    .addressView_left_span1{
                        height:40px;
                        font-size:28px;
                        margin-left: 4px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        line-height:40px;
                    }
                }
                .addressView_left_span2{
                    display: flex;
                    margin-top: 14px;
                    margin-left: 48px;
                    width:468px;
                    height:80px;
                    font-size:28px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                }
            }
            .addressView_line{
                margin-left: 28px;
                margin-right: 28px;
                margin-top: 58px;
                width:2px;
                height:80px;
                background:rgba(234,234,234,1);
            }
            .addressView_right{
                margin-left: 14px;
                display: flex;
                flex-direction: column;
                .addressView_right_icon{
                    margin-top: 60px;
                    width: 44px;
                    height: 44px;
                    // background-color: blue;
                }
                .addressView_right_span{
                    margin-top: 4px;
                    height:32px;
                    font-size:22px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:32px;
                }
            }


    }


}
    }

</style>